import { ContainerFluid } from '@/components/container/Container';
import Footer from '@/components/Footer';
import Navbar from '@/components/header/Navbar';
import ScrollToTop from '@/components/scrollToTop/ScrollToTop';

export default function MainLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">{children}</main>
      <ScrollToTop />
      <footer className="backcustomfooter bg-primary-800 text-white">
        <ContainerFluid>
          <Footer />
        </ContainerFluid>
      </footer>
    </div>
  );
}
